/**
 * Wire shape for default-page segments, mirroring `MarketSegmentSelection` in finsight-web.
 * One group per selection row: a corporate product, or the EM market.
 */
export enum MarketSegmentGroupType {
  Product = 'product',
  Market = 'market',
}

export interface IMarketSegmentGroup {
  id: string,
  type: MarketSegmentGroupType,
  marketSegmentIds: string[],
}

export interface IMarketSegmentSelection {
  groups: IMarketSegmentGroup[],
}

export const EMPTY_MARKET_SEGMENT_SELECTION: IMarketSegmentSelection = { groups: [] };
